module.exports = __webpack_public_path__ + "static/media/contact-linkedin.a61cc79b.svg";